import { StudentProxyType } from '@peekapak/types/DataProtocolTypes';
import { getPossessiveForm } from '../../GlobalFunctions';

interface Props {
  student: StudentProxyType;
}

const InvitationControlPrefix = ({ student }: Props) => (
  <p>{getPossessiveForm(`${student.firstName || ''}${' ' || ''}${student.lastName || ''}`.trim())} Parent</p>
);

export default InvitationControlPrefix;
